import React, { Component } from 'react';
import { SketchPicker } from 'react-color';
import { Icon } from 'antd';

export default class ColorEditor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pickerVisible: false,
            selectColor: props.defaultValue || 'rgba(255,255,255,1)',
            elementId: 'color-editor' + Math.random().toString().substring(3)
        }
    }
    componentDidMount() {
        this._blankClick = this.blankClick.bind(this);
        document.addEventListener('click', this._blankClick);
    }
    showPicker() {
        this.setState({
            pickerVisible: !this.state.pickerVisible
        })
    }
    blankClick(e) {
        if (this.isBlank(e.target)) {
            this.setState({
                pickerVisible: false
            });
        }
    }
    isBlank(node) {
        if (node) {
            if (node.id === `${this.state.elementId}`) {
                return false;
            } else {
                return this.isBlank(node.parentNode)
            }
        } else {
            return true;
        }
    }
    componentWillUnmount() {
        document.removeEventListener('click', this._blankClick);
    }
    render() {
        return <div id={this.state.elementId} className="freesia-color-editor" style={{ position: "relative" }}>
            <div style={{
                width: " 100%",
                border: "1px solid #ddd",
                height: "32px",
                display: "inline-block",
                lineHeight: 2,
                position: "relative"
            }} onClick={this.showPicker.bind(this)}>
                <div style={{
                    position: "absolute",
                    top: "1px",
                    left: "1px",
                    bottom: "1px",
                    right: "20px",
                    background: this.state.selectColor
                }}>

                </div>
                <Icon type="down" style={{ position: "absolute", right: "3px", top: "8px" }} />
                &nbsp;
            </div>
            <div style={{ display: `${this.state.pickerVisible ? "block" : "none"}` }}>
                <SketchPicker color={this.state.selectColor} style={{
                    position: "absolute",
                    top: "36px"
                }} onChange={result => {
                    let color = `rgba(${result.rgb.r},${result.rgb.g},${result.rgb.b},${result.rgb.a})`;
                    this.setState({
                        selectColor: color
                    });
                    this.props.onChange && this.props.onChange(color, {
                        colorRgba: color,
                        colorArray: [result.rgb.r, result.rgb.g, result.rgb.b, result.rgb.a]
                    });
                }} />
            </div>
        </div>
    }
}